module.exports = __webpack_public_path__ + "static/img/img-04.45c4519.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-04.jpg
// module id = 87
// module chunks = 0